export const fuzzySearchThreshold = -1000

export const maxWaitRecommendationsTimeout = 3 * 60 * 1000

export const focusedTypes = {
  ACCOUNT: 'account',
  GROUP: 'group',
} as const

export type FocusedTypes = typeof focusedTypes[keyof typeof focusedTypes]

export const accountTableRowStatuses = {
  UNCERTAIN: '01.uncertain',
  EDITED: '02.edited',
  NONE: '03.none',
}

export type AccountTableRowStatus =
  typeof accountTableRowStatuses[keyof typeof accountTableRowStatuses]

export const MAPPING_SOURCES = {
  EXTERNAL: 'external',
  ACCOUNT_RANGE: 'account_range',
  ORIGINAL_NUMBER: 'original_number',
  AI: 'ai',
  EXACT_MATCH: 'exact_match',
  MANUAL: 'manual',
  NONE: 'none',
} as const

export type MappingSource = typeof MAPPING_SOURCES[keyof typeof MAPPING_SOURCES]

export const PROPOSAL_PRIORITY = {
  EXTERNAL: 1,
  ACCOUNT_RANGE: 2,
  ORIGINAL_NUMBER: 3,
  AI: 4,
  EXACT_MATCH: 5,
  MANUAL: 6,
  NONE: 7,
} as const

export type ProposalPriorityLevel =
  typeof PROPOSAL_PRIORITY[keyof typeof PROPOSAL_PRIORITY]

// Map from source to priority level
export const SOURCE_TO_PRIORITY: Record<MappingSource, ProposalPriorityLevel> =
  {
    [MAPPING_SOURCES.EXTERNAL]: PROPOSAL_PRIORITY.EXTERNAL,
    [MAPPING_SOURCES.ACCOUNT_RANGE]: PROPOSAL_PRIORITY.ACCOUNT_RANGE,
    [MAPPING_SOURCES.ORIGINAL_NUMBER]: PROPOSAL_PRIORITY.ORIGINAL_NUMBER,
    [MAPPING_SOURCES.AI]: PROPOSAL_PRIORITY.AI,
    [MAPPING_SOURCES.EXACT_MATCH]: PROPOSAL_PRIORITY.EXACT_MATCH,
    [MAPPING_SOURCES.MANUAL]: PROPOSAL_PRIORITY.MANUAL,
    [MAPPING_SOURCES.NONE]: PROPOSAL_PRIORITY.NONE,
  }

// Map from priority level to source (for reverse lookups)
export const PRIORITY_SOURCES_MAP: Record<
  ProposalPriorityLevel,
  MappingSource
> = {
  [PROPOSAL_PRIORITY.EXTERNAL]: MAPPING_SOURCES.EXTERNAL,
  [PROPOSAL_PRIORITY.ACCOUNT_RANGE]: MAPPING_SOURCES.ACCOUNT_RANGE,
  [PROPOSAL_PRIORITY.ORIGINAL_NUMBER]: MAPPING_SOURCES.ORIGINAL_NUMBER,
  [PROPOSAL_PRIORITY.AI]: MAPPING_SOURCES.AI,
  [PROPOSAL_PRIORITY.EXACT_MATCH]: MAPPING_SOURCES.EXACT_MATCH,
  [PROPOSAL_PRIORITY.MANUAL]: MAPPING_SOURCES.MANUAL,
  [PROPOSAL_PRIORITY.NONE]: MAPPING_SOURCES.NONE,
}
